import { Router, NavigationEnd } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class BrowserNavigationService {

	private _onAppLeave = new Subject<void>();
	private counter = -1;

	get onAppLeave() {
		return this._onAppLeave.asObservable();
	}

	get hasPrevious() {
		return this.counter > 0;
	}

	constructor() {
		const router = inject(Router)
		const location = inject(Location)

		router.events.pipe(
			filter(event => event instanceof NavigationEnd),
		).subscribe(_ => {
			this.counter++;
		});

		location.subscribe(_ => {
			if (this.counter - 1 <= 0) {
				this._onAppLeave.next();
			}
			this.counter--;
		});
	}
}
